import { useEffect, useRef } from 'react';

import { serverRpc } from '~/modules/remote-mic/network/client';
import { songListDelta } from '~/routes/remote-mic/panels/remote-song-list/song-list-delta';
import { useMySongList } from '~/routes/remote-mic/panels/remote-song-list/use-my-song-list';

// The television keeps one list per phone, so a change of singer is sent as the difference between
// the two lists rather than as a second list on top of the first.
const useSendInitialSongList = (send: boolean) => {
  const { savedSongList } = useMySongList();
  const sent = useRef<string[]>([]);
  const connectedAgain = useRef(true);

  useEffect(() => {
    if (!send) {
      connectedAgain.current = true;
      return;
    }

    const { added, deleted } = songListDelta(sent.current, savedSongList);
    sent.current = savedSongList;

    // The television forgets a phone's list after a long drop but keeps it through a short one, so
    // on the way back the whole list goes again, with whatever was taken out in between.
    if (connectedAgain.current) {
      connectedAgain.current = false;
      void serverRpc.songs.sendMyList({ added: savedSongList, deleted });
      return;
    }

    if (added.length > 0 || deleted.length > 0) void serverRpc.songs.sendMyList({ added, deleted });
  }, [send, savedSongList]);
};

export default useSendInitialSongList;
